import { render } from "./Product.vue?vue&type=template&id=d2893d1e&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=d2893d1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2893d1e"

export default script